import React from 'react';
import { COLORS, FONTS, cardStyle, handleInputFocus, handleInputBlur, GradientBanner } from '../signup/signupStyles';

const getProgressMessage = (length) => {
  if (length < 50) return "Keep going - share your experience...";
  if (length < 100) return "Great start. Tell us more...";
  if (length < 150) return "Really good. Almost there...";
  if (length < 200) return "Just a bit more detail...";
  return "Ready to submit.";
};

export const ReflectQuestion = ({ condition, question, answer, onAnswerChange, onSubmit, onBack }) => {
  const progressPercent = Math.min((answer.length / 200) * 100, 100);
  const canSubmit = answer.length >= 200;

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: COLORS.bg, display: 'flex',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px', fontFamily: FONTS.system
    }}>
      <GradientBanner />
      <style>{`
        @media (max-width: 480px) {
          .reflect-question-card { padding: 32px 24px !important; }
        }
      `}</style>
      <div className="reflect-question-card" style={{ ...cardStyle, maxWidth: '600px' }}>
        <div style={{
          fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
          letterSpacing: '1px', color: COLORS.salmon, marginBottom: '16px'
        }}>
          {condition}
        </div>

        <p style={{
          fontFamily: FONTS.serif, fontSize: 'clamp(20px, 4vw, 26px)',
          fontWeight: '600', color: COLORS.text, lineHeight: '1.4', margin: '0 0 24px'
        }}>
          {question}
        </p>

        <textarea
          value={answer}
          onChange={(e) => onAnswerChange(e.target.value)}
          placeholder="Share your experience..."
          style={{
            width: '100%', minHeight: '160px', padding: '20px',
            fontSize: '16px', border: `1.5px solid ${COLORS.border}`,
            borderRadius: '8px', outline: 'none', resize: 'vertical',
            fontFamily: 'inherit', boxSizing: 'border-box',
            transition: 'border-color 0.2s, box-shadow 0.2s'
          }}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
        />

        <div style={{ marginTop: '16px' }}>
          <div style={{
            height: '8px', backgroundColor: `${COLORS.text}15`,
            borderRadius: '4px', overflow: 'hidden', marginBottom: '8px'
          }}>
            <div style={{
              height: '100%', width: `${progressPercent}%`,
              backgroundColor: canSubmit ? '#6b8e23' : COLORS.salmon,
              borderRadius: '4px', transition: 'width 0.3s ease, background-color 0.3s'
            }} />
          </div>
          <p style={{
            fontSize: '13px', margin: 0,
            color: canSubmit ? '#6b8e23' : COLORS.muted,
            fontWeight: canSubmit ? '600' : '400',
            display: 'flex', alignItems: 'center', gap: '6px'
          }}>
            {getProgressMessage(answer.length)}
            <span style={{ marginLeft: 'auto', opacity: 0.5, fontSize: '12px' }}>
              {answer.length}/200
            </span>
          </p>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button onClick={onBack} style={{
            padding: '14px 24px', fontSize: '15px', fontWeight: '600', color: COLORS.text,
            backgroundColor: 'transparent', border: `1.5px solid ${COLORS.border}`,
            borderRadius: '8px', cursor: 'pointer'
          }}>Back</button>
          <button onClick={onSubmit} disabled={!canSubmit} style={{
            flex: 1, padding: '14px 24px', fontSize: '16px', fontWeight: '600', color: '#fff',
            background: canSubmit ? `linear-gradient(135deg, ${COLORS.salmon} 0%, ${COLORS.peach} 50%, ${COLORS.gold} 100%)` : '#ccc',
            border: 'none', borderRadius: '8px',
            cursor: canSubmit ? 'pointer' : 'not-allowed',
            transition: 'transform 0.2s, box-shadow 0.2s'
          }}
            onMouseEnter={(e) => { if (canSubmit) { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(235, 160, 155, 0.4)'; } }}
            onMouseLeave={(e) => { if (canSubmit) { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; } }}
          >Submit Answer</button>
        </div>
      </div>
    </div>
  );
};
